import { Card, CardBody, Skeleton } from '@vnetwork/ui/primitives';
import { Stat, StatGroup } from '@vnetwork/ui/data';
import { useBusinessStats } from '@/api/businesses-admin';

/**
 * Stats band for the HRM businesses admin list — mirrors the legacy StatsHRM
 * widget. Shows total, pending, leader-approved, approved, rejected+cancelled.
 */
export function BusinessesAdminStatBand() {
  const { data: stats, isLoading } = useBusinessStats();

  return (
    <Card flat style={{ marginBottom: 'var(--vn-space-4)' }}>
      <CardBody>
        {isLoading ? (
          <StatGroup columns={5}>
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={i} style={{ height: 56 }} />
            ))}
          </StatGroup>
        ) : (
          <StatGroup columns={5}>
            <Stat
              label="Total requests"
              value={(stats?.total_requests ?? 0).toLocaleString('en-US')}
              dotColor="var(--vn-primary-solid)"
            />
            <Stat
              label="Pending"
              value={(stats?.pending_count ?? 0).toLocaleString('en-US')}
              dotColor="var(--vn-warning-solid)"
            />
            <Stat
              label="Leader approved"
              value={(stats?.leader_approved_count ?? 0).toLocaleString('en-US')}
              dotColor="var(--vn-info-solid)"
            />
            <Stat
              label="Approved"
              value={(stats?.approved_count ?? 0).toLocaleString('en-US')}
              dotColor="var(--vn-success-solid)"
            />
            <Stat
              label="Rejected / Cancelled"
              value={(
                (stats?.rejected_count ?? 0) + (stats?.cancelled_count ?? 0)
              ).toLocaleString('en-US')}
              dotColor="var(--vn-danger-solid)"
            />
          </StatGroup>
        )}
      </CardBody>
    </Card>
  );
}
